import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Row, Col  } from "react-bootstrap";

import { ButtonStandard, SustainabilityFilter } from "../../components";
import "./SustainabilityList.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'
import { downloadFile } from '../../utils/utilFile';

function SustainabilityList(props) {

	const dispatch = useDispatch();
	const history = useHistory();

	const lang = useSelector(state => state.language.name);

	const sustainabilityList  = useSelector(state => state.conciliationResult.sustainabilityList);
    const sustainabilityState = useSelector(state => state.conciliationResult);
	const selectedCertificate = useSelector(state => state.conciliationResult.selectedCertificate);
	const downloadSustainabilityFile = useSelector(state => state.conciliationResult.downloadSustainabilityFile);
	const downloadSustainabilityLoading = useSelector(state => state.conciliationResult.downloadSustainabilityLoading);
	const sustainabilityCsvList = useSelector(state => state.conciliationResult.sustainabilityCsvList);
	const isLoadingSustainabilityReport = useSelector(state => state.conciliationResult.isLoadingSustainabilityReport);

    const [sustainabilityId, setSustainabilityId] = useState(undefined);
    const [pedido, setPedido] = useState(undefined);

	const pageMessages = messages[lang].sustainabilityListPage;
	const titleTable   = messages[lang].sustainabilityCertificates;
    const titlePage    = messages[lang].sustainabilityInquiry;

	let headerCsv = [
		pageMessages.numeroPedido,
		pageMessages.codigoCertificado,
		pageMessages.statusAuditoria,
		pageMessages.tipoCertificado,
		pageMessages.naturezaPedido,
		pageMessages.certificadoValido,
		pageMessages.idUDA,
		pageMessages.codigoUDA,
		pageMessages.descricaoUDA,
		pageMessages.conciliacaoAprovada,
		pageMessages.avaliacao,
		pageMessages.anotacoes,
		pageMessages.dataCadastro,
		pageMessages.dataModificacao,
		pageMessages.dataExpedicao,
		pageMessages.dataValidade,
		pageMessages.certificadoComPeriodoVigenciaAtivo,
		pageMessages.qtdBCCUs,
		pageMessages.codigoODNRepetido,
		pageMessages.codigoCertificadoODN,
		pageMessages.qtdBCCUsDentroDaMargemDeErro,
		pageMessages.nomeFornecedor,
		pageMessages.semanaComercial,
		pageMessages.qtdePecas
	];

	const header = [
		pageMessages.codigoCertificado,
        pageMessages.statusAuditoria,
        pageMessages.tipoCertificado,
        pageMessages.numeroPedido,
        pageMessages.naturezaPedido,
        pageMessages.fornecedor,
        pageMessages.dataModificacao,
        pageMessages.certificadoValido,
		pageMessages.detalhes,
		'',
	];

    const filters = useSelector(state => state.sustainabilityFilter.filter);
  
    useEffect(() => {
		dispatch({
			type: 'GET_SUSTAINABILITY_LIST',
			page: sustainabilityState.sustainabilityListPage,
			filter: filters
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const formatDateHour = date => {
		let dateSplit = date.split('-')
		let daySplit = dateSplit[2].split(' ')
		let hourSplit = daySplit[1].split(':')
		let returnDate = `${daySplit[0]}/${dateSplit[1]}/${dateSplit[0]} ${hourSplit[0]}:${hourSplit[1]}`

		return returnDate; 
	} 

	const formatDateCsv = date => {
		let dateSplit = date.split('-')
		let returnDate = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`

		return returnDate; 
	}

	useEffect(() => {
		if (selectedCertificate) {
			history.push({
				pathname: '/sustainability-status',
				from: '/sustainability-list',
				orderId: selectedCertificate.numeroPedido,
				tipoCertificado: selectedCertificate.tipoCertificado
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedCertificate]);

	useEffect(() => {
		if (sustainabilityCsvList.length > 0) {
			let transformSustainabilityToDownload =
			sustainabilityCsvList
					.map(item => ([
						item.orderId ? item.orderId : '',
						item.codigoCertificado ? item.codigoCertificado : '',
						item.statusAuditoria ? item.statusAuditoria : '',
						item.tipoCertificado ? item.tipoCertificado : '',
						item.naturezaPedido ? item.naturezaPedido : '',
						item.certificadoValido ? item.certificadoValido : '',
						item.idUDA ? item.idUDA : '',
						item.codigoUDA ? item.codigoUDA : '',
						item.descricaoUDA ? item.descricaoUDA : '',
						item.conciliacaoAprovada ? item.conciliacaoAprovada : '',
						item.avaliacao ? item.avaliacao : '',
						item.anotacoes ? item.anotacoes : '',
						item.dataCadastro ? formatDateHour(item.dataCadastro) : '',
						item.dataModificacao ? formatDateHour(item.dataModificacao) : '',
						item.dataExpedicao ? formatDateCsv(item.dataExpedicao) : '',
						item.dataValidade ? formatDateCsv(item.dataValidade) : '',
						item.certificadoComPeriodoVigenciaAtivo ? item.certificadoComPeriodoVigenciaAtivo : '',
						item.qtdBCCUs ? item.qtdBCCUs : '',
						item.codigoODNRepetido ? item.codigoODNRepetido : '',
						item.codigoCertificadoODN ? item.codigoCertificadoODN : '',
						item.qtdBCCUsDentroDaMargemDeErro ? item.qtdBCCUsDentroDaMargemDeErro : '',
						item.nomeFornecedor ? item.nomeFornecedor : '',
						item.semanaComercial ? item.semanaComercial : '',
						item.qtdePecas ? item.qtdePecas : '',
					]));
			
			const filename = titleTable + `.csv`;
			const textCsv = mountCsvText([headerCsv, ...transformSustainabilityToDownload]);
			downloadFile(textCsv, filename);
			
			dispatch({
				type: 'SET_SUSTAINABILITY_CSV_LIST',
				payload: []
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sustainabilityCsvList]);

	const mountCsvText = (arrayToText) => {
		const separator = ';';
		return arrayToText.reduce((csvText, currentRow) => {

			const rowText = currentRow.reduce((csvRow, currentColumn) => {
				return csvRow ? `${csvRow}${separator}${currentColumn}` : currentColumn
			}, '');

			return csvText ? `${csvText}\n${rowText}` : rowText
		}, '');
	}

    const handleHasMore = () => {
		dispatch({
			type: 'GET_SUSTAINABILITY_LIST',
			page: sustainabilityState.sustainabilityListPage,
			filter: filters
		})
	}

	const mappedSustainabilityList = () => {               
		return sustainabilityList.map((item) => {
			return [
					{
						text: item.codigoCertificado || '---',
						className: 'small-font'
					},
					{
						text: item.statusAuditoria || '---',
					},
					{
						text: item.tipoCertificado || '---',
						maxLength: 30
					},
					{
						text: item.numeroPedido || '---',
					},
					{
						text: item.naturezaPedido || '---',
					},
					{
						text: item.fornecedor || '---',
						maxLength: 20
					},
					item.dataModificacao
						?
							{					
								text: item.dataModificacao,
								type: 'datehour',
							}
						:
						item.dataCriacao
							?
								{					
									text: item.dataCriacao,
									type: 'datehour',
								}
							:
								{
									text: '--/--/----'
								},
					{
						text: item.certificadoValido || '---',
					},
					{
						text: <i className="icon-pen" />,
						onClick: () => {
							dispatch({
								type: 'SET_SELECTED_CERTIFICATE',
								payload: item
							})
						},
					}, 
					{
						text: <ButtonStandard
								icon="icon-download"
								isLoading={downloadSustainabilityLoading && item.idCertificado === sustainabilityId}
								disabled={downloadSustainabilityLoading && item.idCertificado !== sustainabilityId}
								className="btn btn-light btn-rounded btn-hover"
								onClick={() => handleDownloadFile(item)} />
					}
				]

		});
	}

	const handleDownloadFile = (item) => {
		setSustainabilityId(item.idCertificado);
		setPedido(item.numeroPedido);
		dispatch({
			type: 'GET_DOWNLOAD_SUSTAINABILITY_FILE',
			payload: item.idCertificado
		})
	}

	const getDeclarations = () => {
		dispatch({
			type: 'GET_SUSTAINABILITY_LIST',
			page: 1,
			filter: filters,
			cleanTable: true
		})
	}

	const getReport = () => {
		dispatch({
			type: 'GET_SUSTAINABILITY_REPORT',
			filter: filters,
		})
	}

	useEffect(() => {
		if (downloadSustainabilityFile) {
			downloadPdf(downloadSustainabilityFile);
			dispatch({ type: "DOWNLOAD_SUSTAINABILITY_FILE", payload: undefined});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [downloadSustainabilityFile]);

	const downloadPdf = (file) => {
		const byteCharacters = window.atob(file);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		const blob = new Blob([byteArray], { type: 'application/pdf' });

		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = messages[lang].filePDFSustainabilityCertificateFormat.replace('$1', pedido);
		link.click();
	}

	return (
		<div className="sustainability-list-page">
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
                <SustainabilityFilter />
            </Container>

            <Container className="px-4 d-flex justify-content-end">
				<ButtonStandard
					text={messages[lang].getReport}
					textClass="text-1"
					isLoading={isLoadingSustainabilityReport}
					disabled={isLoadingSustainabilityReport}
					className="btn-primary btn-sm btn-standard px-2 mr-2"
					onClick={() => getReport()}/>

				<ButtonStandard
					text={messages[lang].searchCertificate}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getDeclarations()}/>
			</Container>

            <Container className="pt-3 justify-content-start">
                <Container className="mt-1 pt-1 mb-4 pb-5">
                    <ItemList
                        header={header}
                        titleTable={titleTable}
                        listTable={mappedSustainabilityList()}
                        isLoading={sustainabilityList.length > 0 ? false : true}
                        hasMore={sustainabilityState.sustainabilityListHasMore}
                        handleHasMore={handleHasMore}
                        hasMoreIsLoading={sustainabilityState.sustainabilityHasMoreIsLoading}
                        />
                </Container>
            </Container>            
		</div>
	)
}

export default withRouter(SustainabilityList);